import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MessService } from 'src/app/_services/mess-service.service';
import { PackageTypesService } from 'src/app/_services/package-types.service';

@Component({
  selector: 'app-package-types-add',
  templateUrl: './package-types-add.component.html',
})
export class PackageTypesAddComponent implements OnInit, OnDestroy {
  addPackageTypeForm: FormArray;
  disableSave: boolean = true;

  isFromAddPage: boolean = false;
  previousUrl;
  previousUrlSub: Subscription;

  constructor(
    private fb: FormBuilder,
    private messService: MessService,
    private router: Router,
    private route: ActivatedRoute,
    private packageTypesService: PackageTypesService
  ) {}

  // * Lifecycles === //
  ngOnInit(): void {
    // * Create from
    this.addPackageTypeForm = this.fb.array([
      this.fb.group({
        label: ['', Validators.required],
        name: ['', Validators.required],
      }),
    ]);

    // * Check if user come from some ADD page (NIP)
    this.previousUrlSub = this.route.queryParams.subscribe((params) => {
      // Defaults to 0 if no query param provided.
      this.previousUrl = params['fromPage'] || 0;
      this.isFromAddPage = this.previousUrl != 0 ? true : false;
    });
  }

  ngOnDestroy() {
    this.previousUrlSub.unsubscribe();
    this.messService.clearErrors();
  }

  // * Add package type === //
  onAddPackageType() {
    let packageTypes = this.addPackageTypeForm.getRawValue();
    this.packageTypesService.addPackageType(packageTypes).subscribe(
      () => {
        this.messService.add({
          severity: 'success',
          title: 'Uspešno kreiranje',
          detail: 'Kreirali ste novi tip pakovanja.',
        });
        if (this.isFromAddPage) {
          this.router.navigate([this.previousUrl], {
            relativeTo: this.route,
            queryParams: { fromPage: '/partners' },
          });
        } else {
          this.router.navigate(['./../'], { relativeTo: this.route });
        }
      },
      (error) => {
        const errorObj = error.error.errors;
        const indexOfInvalidField = error.error.item - 1;
        const form = this.getControls()[indexOfInvalidField];
        const messService = this.messService;
        Object.keys(errorObj).forEach(function (key) {
          const formControl = form.get(key);
          if (formControl) {
            // If error exist set red border to field
            formControl.setErrors({});
          }
          // Push toast error for every field
          messService.addError({
            severity: 'error',
            title: 'Greška',
            detail: errorObj[key],
            sticky: true,
          });
        });
      }
    );
  }

  // * Helpers === //
  getControls() {
    return (<FormArray>this.addPackageTypeForm).controls;
  }

  createProductType(): FormGroup {
    return this.fb.group({
      label: ['', Validators.required],
      name: ['', Validators.required],
    });
  }

  addPackageType(): void {
    this.addPackageTypeForm.push(this.createProductType());
  }

  removePackageType(productTypeId: number): void {
    this.addPackageTypeForm.removeAt(productTypeId);
  }
}
